import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileText, PenSquare, Inbox, Bell, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

function Tab({ to, icon: Icon, label, testId }) {
  return (
    <NavLink
      to={to}
      end
      data-testid={testId}
      className={({ isActive }) =>
        `flex flex-col items-center gap-1 px-2 py-1 flex-1 rounded-2xl transition-all ${
          isActive
            ? "text-white"
            : "text-[#9AA4B2]"
        }`
      }
    >
      {({ isActive }) => (
        <>
          <div
            className={`w-9 h-9 rounded-2xl flex items-center justify-center ${
              isActive
                ? "bg-gradient-to-br from-[#2563EB] to-[#4F46E5] shadow-[0_0_18px_-2px_rgba(79,70,229,0.7)]"
                : ""
            }`}
          >
            <Icon size={18} />
          </div>
          <span className="text-[10px] font-medium">{label}</span>
        </>
      )}
    </NavLink>
  );
}

export function MobileTabBar() {
  const { user } = useAuth();
  if (!user) return null;
  const role = user.role;
  return (
    <nav
      className="lg:hidden fixed bottom-4 left-4 right-4 glass rounded-full px-3 py-2 z-40 flex items-center justify-between shadow-2xl"
      data-testid="mobile-tab-bar"
    >
      <Tab to="/dashboard" icon={LayoutDashboard} label="Home" testId="mtab-home" />
      <Tab to="/library" icon={FileText} label="Library" testId="mtab-library" />
      {(role === "champion" || role === "admin") && (
        <Tab to="/create" icon={PenSquare} label="Create" testId="mtab-create" />
      )}
      {(role === "owner" || role === "admin") && (
        <Tab to="/approvals" icon={Inbox} label="Reviews" testId="mtab-approvals" />
      )}
      <Tab to="/notifications" icon={Bell} label="Alerts" testId="mtab-notif" />
      <Tab to="/profile" icon={User} label="Me" testId="mtab-profile" />
    </nav>
  );
}
